let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("38N5I")).then(() => parcelRequire('9wtJH'));